import {createApp} from 'vue';
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import './index.css'
import {createStore} from 'vuex'
import axios from 'axios'


let headers = {'content-type': 'application/json'}
let URL = "https://helpinghands-backend.herokuapp.com/"
export const store = createStore({
    state() {
        return {
            currentStates: '',
            currentCity: [],
            currentResource: '',
            allPosts: '',
            loading: false,
            filteredCity: [],
        }
    },
    mutations: {

        setCurrentState(state, payload) {
            state.currentStates = payload;
        },
        setCurrentCity(state, payload) {
            state.currentCity = payload;
        },
        setCurrentresource(state, payload) {
            state.currentResource = payload;
        },
        setAllPosts(state, payload) {
            state.allPosts = payload
        },
        setFilterCity(state, payload) {
            if (payload === null || payload === "") {
                let SuggetionState = []
                let StName = ["Lucknow", "Pune","New Delhi", "Ahmedabad","Gurgaon" , "Nagpur" ]
                let data = state.currentCity.filter(city => {
                    city['Name'].toLowerCase()
                    for (let i = 0; i < StName.length; i++) {
                            if(city['Name'] === StName[i] ){
                                SuggetionState.push(city)
                        }
                    }
                })
                state.filteredCity = SuggetionState
            } else {
                let data = state.currentCity.filter(city => city['Name'].toLowerCase().indexOf(payload.toLowerCase()) !== -1)
                if (data.length > 5) {
                    state.filteredCity = data.slice(0, 5)
                } else {
                    state.filteredCity = data
                }
            }
        }
    },
    actions: {
        async fetchCity(context) {
            let data = await axios.post(URL + 'getCity', headers);
            data = data['data']['data']
            context.commit('setCurrentCity', data)
        },
        async fetchPosts(context) {
            let res = await axios.post(URL + 'posts');
            res = res['data']['data']
            context.commit('setAllPosts', res)
        },
        async fetchResources(context) {
            let data = await axios.post(URL + 'getresources', headers);
            data = data['data']['data']
            context.commit('setCurrentresource', data)
        },
        async fetchState(context) {
            let data = await axios.post(URL + 'getstate', headers);
            data = data['data']['data']
            context.commit('setCurrentState', data)
        },
        async setCityAction(context, payload) {
            context.commit('setFilterCity', payload)
        },
        async setSelectedCity({state}) {
            state.filteredCity = []
        },
    },
    getters: {
        getCurrentCity: state => state.currentCity,
        getCurrentresource: state => state.currentResource
    }
});

const myapp = createApp(App);
myapp.use(store)
myapp.use(router).mount('#app')

